import moment from 'moment';

// 测试打印数据
export const testData = {
  // 交接班
  '8': {
    head: 'MAMAMIYA',
    operation: [
      { operation_cloumn: '操作员名称', operation_value: 'Admin' },
      { operation_cloumn: '交接班编号', operation_value: '2' },
      { operation_cloumn: '收银机名称', operation_value: 'LAPTOP-0694GUJU' }
    ],
    time: [
      { time_cloumn: '开始时间', time_value: `${moment(new Date()).subtract(1, 'day').format('DD/MM/YYYY HH:mm:ss')}` },
      { time_cloumn: '结束时间', time_value: `${moment(new Date()).format('DD/MM/YYYY HH:mm:ss')}` }
    ],
    total: [
      { total_cloumn: '销售总额', total_value: '300.66' },
      { total_cloumn: '折扣额', total_value: '-12.88' },
      { total_cloumn: '向上抹零', total_value: '0.00' },
      { total_cloumn: '实收总额', total_value: '287.78' },
      { total_cloumn: '总应税额', total_value: '29.89' },
      { total_cloumn: '小费总金额', total_value: '2.00' },
      { total_cloumn: '小费笔数', total_value: '1.00' },
      { total_cloumn: '小费总税额', total_value: '0.18' },
      { total_cloumn: '服务费总金额', total_value: '2.00' },
      { total_cloumn: '服务费笔数', total_value: '1.00' },
      { total_cloumn: '服务费总税额', total_value: '0.18' }
    ],
    order: [
      { order_cloumn: '订单数', order_value: '5' },
      { order_cloumn: '客人数', order_value: '14' },
      { order_cloumn: '外卖金额', order_value: '0.00' },
      { order_cloumn: '外卖订单数', order_value: '0' },
      { order_cloumn: '堂食金额', order_value: '300.66' },
      { order_cloumn: '堂食订单数', order_value: '5' },
      { order_cloumn: '堂食平均订单价', order_value: '60.13' },
      { order_cloumn: '堂食人均单价', order_value: '21.48' },
      { order_cloumn: '外送平均订单价', order_value: '0.00' }
    ],
    payment: '付款信息',
    payments: [
      {
        payments_cloumn: '现金￥',
        payments_value: '116.59 (Rec.: 116.59; Inv.: 0.00)',
        payments_cloumn_num: '现金￥ 数量',
        payments_value_num: '1'
      }
    ],
    payments_total: [
      { payments_total_cloumn: '合计', payments_total_value: '116.59' }
    ],
    cashbox: '钱箱金额',
    cashboxs: [
      { cashboxs_cloumn: '存入', cashboxs_value: '0.00' },
      { cashboxs_cloumn: '取出', cashboxs_value: '0.00' },
      { cashboxs_cloumn: '合计', cashboxs_value: '0.00' }
    ],
    annullation: '退菜',
    annullations: [
      { annullations_cloumn: '退菜数量', annullations_value: '8' },
      { annullations_cloumn: '退菜金额', annullations_value: '24.99' }
    ],
    reprice: '重定价',
    reprices: [
      { reprices_cloumn: '重定价数量', reprices_value: '0' },
      { reprices_cloumn: '重定价金额', reprices_value: '0.00' }
    ],
    opaned: '未结订单',
    opaneds: [
      { opaned_cloumn: '未结订单数', opaned_value: '34' },
      { opaned_cloumn: '未结金额', opaned_value: '1119.50' }
    ],
    abortpays: [
      { abortpay_cloumn: '反结账数量', abortpay_value: '4' }
    ],
    abortpay: '详情见敏感操作记录页面'
  },
  // 销售总结
  '9': {
    head: 'MAMAMIYA',
    restaurant: [
      { restaurant_value: `${moment(new Date()).format('DD/MM/YYYY')}   -   ${moment(new Date()).add(1, 'day').format('DD/MM/YYYY')}` },
    ],
    operation: [
      { operation_cloumn: '操作员名称', operation_value: 'Admin' }
    ],
    time: [],
    total: [
      { total_cloumn: '销售总额', total_value: '116.59' },
      { total_cloumn: '折扣额', total_value: '0.00' },
      { total_cloumn: '向上抹零', total_value: '0.00' },
      { total_cloumn: '实收总额', total_value: '116.59' },
      { total_cloumn: '总应税额', total_value: '7.82' },
      { total_cloumn: '小费总金额', total_value: '0.00' },
      { total_cloumn: '小费笔数', total_value: '0.00' },
      { total_cloumn: '小费总税额', total_value: '0.00' },
      { total_cloumn: '服务费总金额', total_value: '0.00' },
      { total_cloumn: '服务费笔数', total_value: '0.00' },
      { total_cloumn: '服务费总税额', total_value: '0.00' }
    ],
    order: [
      { order_cloumn: '订单数', order_value: '1' },
      { order_cloumn: '客人数', order_value: '1' },
      { order_cloumn: '外卖金额', order_value: '0.00' },
      { order_cloumn: '外卖订单数', order_value: '0' },
      { order_cloumn: '堂食金额', order_value: '116.59' },
      { order_cloumn: '堂食订单数', order_value: '1' },
      { order_cloumn: '堂食平均订单价', order_value: '116.59' },
      { order_cloumn: '堂食人均单价', order_value: '116.59' },
      { order_cloumn: '外送平均订单价', order_value: '0.00' }
    ],
    business_arr: [
      { business_cloumn: '早上(06:00-17:59) 客人数', business_value: '1' },
      { business_cloumn: '早上(06:00-17:59) 堂食', business_value: '1' }
    ],
    taxes: '税率组：',
    tax: [
      { tax_cloumn: '未税额 Non-GST', tax_value: '31.45' },
      { tax_cloumn: '应税额 Non-GST', tax_value: '3.14' },
      { tax_cloumn: '已税总额 Non-GST', tax_value: '34.59' },
      { tax_cloumn: '未税额 (di cui IVA)', tax_value: '1.67' },
      { tax_cloumn: '应税额 (di cui IVA)', tax_value: '0.33' },
      { tax_cloumn: '已税总额 (di cui IVA)', tax_value: '2.00' }
    ],
    payment: '付款信息：',
    payments: [
      {
        payments_cloumn: '现金￥',
        payments_value: '116.59 (Rec.: 116.59; Inv.: 0.00)',
        payments_cloumn_num: '现金￥ 数量',
        payments_value_num: '1'
      }
    ],
    payments_total: [
      { payments_total_cloumn: '合计', payments_total_value: '116.59' }
    ],
    cashbox: '',
    cashboxs: [],
    annullation: '退菜：',
    annullations: [
      { annullations_cloumn: '退菜数量', annullations_value: '4' },
      { annullations_cloumn: '退菜金额', annullations_value: '6.99' }
    ],
    reprice: '重定价：',
    reprices: [
      { reprices_cloumn: '重定价数量', reprices_value: '0' },
      { reprices_cloumn: '重定价金额', reprices_value: '0.00' }
    ],
    prints: [],
    abortpays: [
      { abortpay_cloumn: '反结账数量', abortpay_value: '0' }
    ],
    abortpay: '详情见敏感操作记录页面'
  },
  // 堂食送厨单
  '10': {
    template: 'send_order',
    head: 'CASSA',
    eat_type: 'Eat In',
    printer_type: 3,
    paper_width: 80,
    cut_paper: 1,
    printer: '192.168.3.241',
    tbl_name: '9',
    chk_num: 455,
    time: `${moment(new Date()).format('yyyy-MM-DD HH:mm:ss')}`,
    items: [
      {
        num: '1.00',
        name: 'Louis Roederer Brut  ',
        name2: 'LOUIS ROEDERER BRUT ',
        desc: 'good',
        round: 'RND 2'
      },

    ],
    emp_name: 'user',
    chk_name: 'chk_name',
    gst_num: 2,
    remark: 'remark',
    round: '1'
  },
  // 取餐单
  '11': {
    get_meal_code: '445',
    template: 'get_meal',
    printer_type: 3,
    paper_width: 80,
    cut_paper: 1,
    printer: '192.168.3.241',
    time: `${moment(new Date()).format('yyyy-MM-DD HH:mm:ss')}`,
    items: [
      {
        num: '3.00',
        name: 'Ribolla Gialla Collio Doc ',
        name2: 'RIBOLLA GIALLA COLLIO DOC '
      }
    ]
  },
  // 外卖总单
  '12': {
    template: 'delivery',
    eat_type: 'Take away',
    printer_type: 3,
    paper_width: 80,
    cut_paper: 1,
    printer: '192.168.3.241',
    head: 'dish ordh hhe\nVia Brigata Liguria, 72R Genova\nP.iva 02650480995\nefeee\n',
    chk_id: 1,
    tainfo: 'aaaaa,3008515151\n5050\ngood meal',
    serial: 1106,
    emp_name: '102',
    chk_num: 447,
    open_time: `${moment(new Date()).format('HH:mm:ss DD/MM/yyyy')}`,
    id: 1106,
    subtotal: '455.00',
    chk_total: '455.00',
    order_val: '455.00',
    delivery_val: '0.00',
    end_time: `${moment(new Date()).format('HH:mm:ss DD/MM/yyyy')}`,
    remark: 'remark',
    order_remark: '',
    tax_name: 'Tax',
    tax: '41.36',
    taxs: [
      {
        'tax_group_id': -1,
        'tax_item_name': '(di cui IVA)',
        'tax_rate': 10,
        'tax_fee': 2.43,
        'amount_with_tax': 26.64,
        'amount_without_tax': 24.21
      },
      {
        'tax_group_id': 1,
        'tax_item_name': 'Non-GST',
        'tax_rate': 10,
        'tax_fee': 3.69,
        'amount_with_tax': 40.54,
        'amount_without_tax': 36.85
      }
    ],
    items: [
      {
        num: '2.00',
        total: '140.00',
        price: '70.00',
        name: 'Louis Roederer Brut ',
        name2: 'LOUIS ROEDERER BRUT ',
        desc: 'good'
      },
      {
        num: '3.00',
        total: '315.00',
        price: '105.00',
        name: 'Ruinart Brut Blanc De ',
        name2: 'RUINART BRUT BLANC DE ',
        desc: 'good'
      }
    ],
    discounts: [
      {
        dis_name: '10% Sconto',
        dis_val: -12.54
      },
      {
        dis_name: '20% Sconto',
        dis_val: -20.94
      },
      {
        dis_name: 'Discount',
        dis_val: -27.97
      }
    ],
    desc: 'desc',
    eat_time: '14:10',
  },
  // 外卖送厨单
  '13': {
    tbl_name: 'Quick Service',
    template: 'send_order_kc',
    remark: 'Hhh',
    chk_name: '',
    head: 'CASSA',
    eat_type: 'Delivery',
    printer_type: 3,
    paper_width: 80,
    cut_paper: 1,
    printer: '192.168.3.241',
    chk_num: 444,
    tainfo: `ww 4555556\n${moment(new Date()).format('yyyy-MM-DD HH:mm:ss')}`,
    time: `${moment(new Date()).format('yyyy-MM-DD HH:mm:ss')}`,
    items: [
      {
        num: '1.00',
        name: 'Cuvee Spumante Extra Dry',
        name2: 'CUVEE SPUMANTE EXTRA DRY',
        id: 104,
        desc: 'good'
      },
      {
        num: '2.00',
        name: 'Ferrari Maximum Brut Doc',
        name2: 'FERRARI MAXIMUM BRUT DOC',
        id: 103,
        desc: 'good'
      }
    ],
    emp_name: 'user',
    delivery_time: '14:10'
  },
  // 预结单
  '14': {
    template: 'prepayment',
    head: 'dish ordh hhe\nVia Brigata Liguria, 72R Genova\nP.iva 02650480995\nefeee\n',
    eat_type: 'Eat in',
    printer_type: 3,
    paper_width: 80,
    cut_paper: 1,
    printer: '192.168.3.241',
    chk_id: 1,
    serial: 1096,
    emp_name: '102',
    chk_num: 437,
    open_time: `${moment(new Date()).format('HH:mm DD/MM/yyyy')}`,
    subtotal: '2.00',
    chk_total: '2.00',
    tbl_name: '6',
    gst_num: 1,
    end_time: `${moment(new Date()).format('yyyy-MM-DD HH:mm:ss')}`,
    tax_name: 'Tax',
    tax: 0.18,
    taxs: [
      {
        'tax_group_id': -1,
        'tax_item_name': '(di cui IVA)',
        'tax_rate': 10,
        'tax_fee': 2.43,
        'amount_with_tax': 26.64,
        'amount_without_tax': 24.21
      },
      {
        'tax_group_id': 1,
        'tax_item_name': 'Non-GST',
        'tax_rate': 10,
        'tax_fee': 3.69,
        'amount_with_tax': 40.54,
        'amount_without_tax': 36.85
      }
    ],
    items: [
      {
        num: '1',
        price: '1.00',
        name: '19BB.Tartar speciale',
        total: '1.00',
        name2: '4BB.Tartar speciale',
        desc: 'good',
      },
      {
        num: '1',
        price: '1.00',
        name: '20A.Ita style roll fritto',
        total: '1.00',
        name2: '2A.Ita style roll fritto',
        desc: 'good',
      }
    ],
    tainfo: '',
    discounts: [
      {
        dis_name: '10% Sconto',
        dis_val: -12.54
      },
      {
        dis_name: '20% Sconto',
        dis_val: -20.94
      },
      {
        dis_name: 'Discount',
        dis_val: -27.97
      }
    ],
    remark: 'next',
    chk_name: 'smartway',
    discount_amount: '5.00',
    signature: 'fjeojfelhfelfhfjbejkbknlwiehbfb',
    'certificate_no.': '9999',
    ext_sig: 'eefb',
    'SW_Ver.': 'v1.0.244'
  },
  // 收据单
  '15': {
    template: 'payment',
    head: 'dish ordh hhe\nVia Brigata Liguria, 72R Genova\nP.iva 02650480995\nefeee\n',
    eat_type: 'Eat in',
    printer_type: 3,
    paper_width: 80,
    cut_paper: 1,
    printer: '192.168.3.241',
    chk_id: 1,
    serial: '42',
    emp_name: 'user',
    chk_num: 437,
    tbl_name: '6',
    open_time: `${moment(new Date()).format('DD/MM/yyyy HH:mm')}`,
    subtotal: '2.00',
    chk_total: '2.00',
    gst_num: 1,
    end_time: `${moment(new Date()).format('DD/MM/yyyy HH:mm')}`,
    tax_name: 'Tax',
    tax: 0.18,
    taxs: [
      {
        'tax_group_id': -1,
        'tax_item_name': '(di cui IVA)',
        'tax_rate': 10,
        'tax_fee': 2.43,
        'amount_with_tax': 26.64,
        'amount_without_tax': 24.21
      },
      {
        'tax_group_id': 1,
        'tax_item_name': 'Non-GST',
        'tax_rate': 10,
        'tax_fee': 3.69,
        'amount_with_tax': 40.54,
        'amount_without_tax': 36.85
      }
    ],
    tainfo: '',
    discounts: [
      {
        dis_name: '10% Sconto',
        dis_val: -12.54
      },
      {
        dis_name: '20% Sconto',
        dis_val: -20.94
      },
      {
        dis_name: 'Discount',
        dis_val: -27.97
      }
    ],
    items: [
      {
        num: '1',
        price: '1.00',
        name: '19BB.Tartar speciale',
        total: '1.00',
        name2: '',
        desc: 'good'
      },
      {
        num: '1',
        price: '1.00',
        name: '20A.Ita style roll',
        total: '1.00',
        name2: '',
        desc: 'good'
      }
    ],
    pays: [{ pay_name: 'Carta', pay_val: '2.00', name: 'Carta:2.00' }],
    discount: '5.00',
    payment_queue_id: 100,
    Arrotondamento: 'AAAA',
    start_time: '23/12/2025 00:00',
    number_to_words: 'BBBB',
    be4_tax: '12.00'
  },
  // 退菜单
  '16': {
    template: 'void_item',
    head: 'CASSA',
    printer_type: 3,
    paper_width: 80,
    cut_paper: 1,
    printer: '192.168.3.241',
    tbl_name: '15',
    chk_num: 1118,
    time: `${moment(new Date()).format('yyyy-MM-DD HH:mm:ss')}`,
    items: [
      {
        num: '1.00',
        name: 'Ferrari Maximum Brut Doc',
        name2: 'FERRARI MAXIMUM BRUT DOC',
        desc: ' SBAGLIATO;asd;'
      }
    ],
    emp_name: 'user',
    gst_num: 3
  },
  // 发票单
  '17': {
    template: 'electronic invoice',
    head: 'Anteprima Fattura',
    Mittente: 'Mittente',
    r_denominazione: 'KANJI BROGGI SRL',
    r_indirizzo: 'VIA BROGGI 17',
    r_city: 'MILANO',
    r_province: 'MI',
    r_cap_comune_provincia: '20129',
    r_idcodice: '08063690963',
    Destinatario: 'Destinatario',
    c_corporate: 'RAFFAELE PORETTO',
    c_address: 'VIALE ZARA 52',
    c_city: 'MILANO',
    c_province: 'MI',
    c_zipcode_city_province: '20124',
    cif: '13054230159',
    nif: '0000000',
    binding_piva: '13054230159',
    codice_destinatario: '0000000',
    i_invoice_id: 3,
    i_edit_time: `${moment(new Date()).format('DD/MM/yyyy')}`,
    items: [
      {
        num: '1',
        price: '10.00',
        name: '37,5cl Pinot Nero In Bianco',
        name2: '37,5cl Ribolla Gialla Igt ',
        desc: 'SBAGLIATO;asd;',
        TAUX: '10.00%'
      },
      {
        num: '1',
        price: '10.00',
        name: '37,5cl Pinot Nero In Bianco',
        name2: '37,5cl Ribolla Gialla Igt',
        desc: 'SBAGLIATO;asd;',
        TAUX: '10.00%'
      }
    ],
    VAT: [
      {
        Code: '1',
        TAUX: '10.00%',
        TVA: 1.82,
        HT: 18.18,
        TTC: '20.00'
      },
    ],
    // TOTAUX_HT: 18.18,
    // TOTAUX_TVA: 1.82,
    // TOTAUX_TTC: '20.00',
    // vat_rate: '10.00%',
    pays: [
      {
        pay_name: 'Espèces',
        pay_val: '20.00',
      }
    ],
    price: '20.00',
    tax_amount: 1.82,
    discount: '5.00',
    total_without_tax: '18.18',
    operator_id: 999,
    legal_form: 'SAS ',
    capital_social: 2000000,
    'certificate_no.': 9999,
    ext_sig: 'xyCa',
    'SW_Ver.': 'v1.0.201',
    r_siret: '99999999999999',
    r_NAF: '62.09Z',
    r_RCS: '767676766',
    c_siret: '88888888888888',
    c_RCS: '889898988',
    signature: 'I6xoAxyUMmVxCm3QuFaZAJxB7vhiKririB9mWjz4',
    r_country: ' France',
    c_country: ' France',
    number_to_words: 'VEINTE LEMPIRAS CON 00/',
    tbl_name: '1',
    chk_num: '888',
    fiskaly_verifactu_title: 'fiskaly AAA',
    fiskaly_verifactu_bottom: 'fiskaly BBB',
    fiskaly_tabi_bottom: 'fiskaly CCC',
    payment_method: 'Cash',
    VAT_Pay_Opt: 'TVA sur les débits',
    r_nif: '000000000',
    emp_name: 'Smartway',
    Arrotondamento: 'AAAA'
  },
  // 划菜打印
  '19': {
    tbl_name: '9',
    chk_num: 888,
    gst_num: 2,
    emp_name: 'user',
    chk_name: 'smartway',
    time: `${moment(new Date()).format('yyyy-MM-DD HH:mm:ss')}`,
    items: [
      {
        num: '1',
        price: '10.00',
        name: '37,5cl Pinot Nero In Bianco',
        name2: '37,5cl Ribolla Gialla Igt ',
        desc: 'SBAGLIATO;asd;',
        TAUX: '10.00%'
      },
      {
        num: '1',
        price: '10.00',
        name: '37,5cl Pinot Nero In Bianco',
        name2: '37,5cl Ribolla Gialla Igt',
        desc: 'SBAGLIATO;asd;',
        TAUX: '10.00%'
      }
    ],
  },
  // 套餐模板
  '20': {
    items: [
      {
        num: '2.00',
        total: '140.00',
        price: '70.00',
        name: 'Louis Roederer Brut ',
        name2: 'LOUIS ROEDERER BRUT '
      },
      {
        num: '3.00',
        total: '315.00',
        price: '105.00',
        name: 'Ruinart Brut Blanc De ',
        name2: 'RUINART BRUT BLANC DE '
      }
    ],
  },
  // 催菜单
  '21': {
    items: [
      {
        num: '2.00',
        total: '140.00',
        price: '70.00',
        name: 'Louis Roederer Brut ',
        name2: 'LOUIS ROEDERER BRUT ',
        desc: 'good'
      },
      {
        num: '3.00',
        total: '315.00',
        price: '105.00',
        name: 'Ruinart Brut Blanc De ',
        name2: 'RUINART BRUT BLANC DE ',
        desc: 'good'
      }
    ],
    tbl_name: '9',
    chk_num: 455,
    time: `${moment(new Date()).format('yyyy-MM-DD HH:mm:ss')}`,
    emp_name: 'user',
    chk_name: 'chk_name',
    gst_num: 2,
    remark: 'No spicy'
  },
  // 流水单
  '22': {
    items: [
      {
        payment_type_name: 'Mixed Payment',
        date: '2025-12-10 09:45:56',
        amount: '119.00',
        payment_type_id: null,
        eat_type: '堂食',
        order_id: 2052,
        customer: '',
        payment_type_total: '119.00'
      },
      {
        payment_type_name: 'EFECTIVO',
        date: '2025-12-10 10:49:09',
        amount: '47.30',
        payment_type_id: 1,
        eat_type: '外送',
        order_id: 1173,
        customer: 'Nerea Francisco',
        payment_type_total: '47.30'
      },

    ],
    device_id: 1,
    start_time: '2025-04-02 00:00:00',
    end_time: '2025-04-02 23:59:59',
    time: '2025-04-02 15:16:00'
  },
  // 转台打印
  '23': {
    chk_num: 455,
    gst_num: 2,
    emp_name: 'user',
    time: '2025-04-02 15:16:00',
    from_tbl: '15',
    to_tbl: '10'
  },
  // 西班牙税务收据单
  '24': {
    company_name: 'smartway',
    location_address: 'aaa',
    location_zipcity: 'bbb',
    es_verifactu_title: 'QR tributario:',
    es_verifactu_bottom: 'VERI*FACTU',
    date: '2025-12-09T12:10:02',
    es_tabi_bottom: 'TBAI-46886417C-011225-KvnkMv9Anhazb-039',
    terminal_info: 'Serial: ABC_2025  Receipt: 1',
    title: 'Factura simplificada',
    duplicate: '** DUPLICADO **',
    items: [
      {
        'info_desc': 'test dish1',
        'info_tax': 'A',
        'info_price': '100.00',
        'info_qty_price': '1 pc x 100.00'
      },
      {
        'info_desc': 'test dish2',
        'info_tax': 'A',
        'info_price': '2.00',
        'info_qty_price': '1 pc x 2.00',
      }
    ],
    total_desc: 'T O T A L',
    total_price: '102.00',
    cash_info: [
      {
        'info_desc': 'Efectivo',
        'info_price': '102.00',
      }
    ],
    vat_info: [
      {
        'info_desc': '21%',
        'info_without_amount': '84.29',
        'info_with_amount': '17.71',
        'info_tax_group': 'A',
        'info_tax_amount': '102.00',
      }
    ],

  },
  // 西班牙税务发票单
  '26': {
    client_title: 'Factura',
    client_name: 'client_name',
    client_address: 'client_address',
    client_zipcity: 'client_zipcity',
    client_nif: '12345678A',
    es_verifactu_title: 'QR tributario:',
    es_verifactu_bottom: 'VERI*FACTU',
    date: '2025-12-09T12:10:02',
    es_tabi_bottom: 'TBAI-46886417C-011225-KvnkMv9Anhazb-039',
    terminal_info: 'Serial: ABC_2025  Invoice: 1',
    company_name: 'smartway',
    location_address: 'aaa',
    location_zipcity: 'bbb',
    title: 'Factura',
    duplicate: '** DUPLICADO **',
    items: [
      {
        'info_desc': 'test dish1',
        'info_tax': 'A',
        'info_price': '100.00',
        'info_qty_price': '1 pc x 100.00'
      },
      {
        'info_desc': 'test dish2',
        'info_tax': 'A',
        'info_price': '2.00',
        'info_qty_price': '1 pc x 2.00',
      }
    ],
    total_desc: 'T O T A L',
    total_price: '102.00',
    cash_info: [
      {
        'info_desc': 'Efectivo',
        'info_price': '102.00',
      }
    ],
    vat_info: [
      {
        'info_desc': '21%',
        'info_without_amount': '84.29',
        'info_with_amount': '17.71',
        'info_tax_group': 'A',
        'info_tax_amount': '102.00',
      }
    ]
  },
  // 订单总单
  '29': {
    template: 'delivery',
    eat_type: 'Take away',
    printer_type: 3,
    paper_width: 80,
    cut_paper: 1,
    printer: '192.168.3.241',
    head: 'dish ordh hhe\nVia Brigata Liguria, 72R Genova\nP.iva 02650480995\nefeee\n',
    chk_id: 1,
    tainfo: 'aaaaa,3008515151\n5050\ngood meal',
    serial: 1106,
    emp_name: '102',
    chk_num: 447,
    open_time: `${moment(new Date()).format('HH:mm:ss DD/MM/yyyy')}`,
    id: 1106,
    subtotal: '455.00',
    chk_total: '455.00',
    order_val: '455.00',
    delivery_val: '0.00',
    end_time: `${moment(new Date()).format('HH:mm:ss DD/MM/yyyy')}`,
    remark: 'aaaaa',
    chk_name: 'bbbbb',
    order_remark: '',
    tax_name: 'Tax',
    tax: '41.36',
    taxs: [
      {
        'tax_group_id': -1,
        'tax_item_name': '(di cui IVA)',
        'tax_rate': 10,
        'tax_fee': 2.43,
        'amount_with_tax': 26.64,
        'amount_without_tax': 24.21
      },
      {
        'tax_group_id': 1,
        'tax_item_name': 'Non-GST',
        'tax_rate': 10,
        'tax_fee': 3.69,
        'amount_with_tax': 40.54,
        'amount_without_tax': 36.85
      }
    ],
    items: [
      {
        num: '2.00',
        total: '140.00',
        price: '70.00',
        name: 'Louis Roederer Brut ',
        name2: 'LOUIS ROEDERER BRUT ',
        desc: 'good',
        round: '1'
      },
      {
        num: '3.00',
        total: '315.00',
        price: '105.00',
        name: 'Ruinart Brut Blanc De ',
        name2: 'RUINART BRUT BLANC DE ',
        desc: 'good',
        round: '2'
      }
    ],
    discounts: [
      {
        dis_name: '10% Sconto',
        dis_val: -12.54
      },
      {
        dis_name: '20% Sconto',
        dis_val: -20.94
      },
      {
        dis_name: 'Discount',
        dis_val: -27.97
      }
    ],
    desc: 'desc',
    eat_time: '14:10',
  },
}

export type TestDataType = keyof typeof testData


export type widthMapType = keyof typeof widthMap

// 字体大小列表
export const fontSizeMap = {
  0: 'unset',
  1: '18px',
  2: '20px',
  3: '22px',
  4: '24px',
  5: '26px',
  6: '28px',
  7: '30px',
}

/** 与 RBP2 `print-template2` 一致的模板 id 白名单 */
export const PRINT_TEMPLATE_WHITE_LIST = [
  10, 11, 12, 13, 14, 15, 16, 17, 19, 20, 21, 22, 23, 24, 26, 29, 8, 9,
] as const

/** Logo / 税务图字段 key（与 RBP2 `LogoKey` 一致） */
export const PRINT_TEMPLATE_LOGO_FIELD_KEYS: readonly string[] = [
  'logo',
  'fiskaly_verifactu_image',
  'fiskaly_tabi_image',
  'es_verifactu_image',
  'es_tabi_image',
]

/** 西班牙税务单中禁止改位置的字段（与 RBP2 `DisableLocationKey` 一致） */
export const PRINT_TEMPLATE_DISABLE_LOCATION_KEYS: readonly string[] = [
  'es_verifactu_title',
  'es_verifactu_image',
  'es_verifactu_bottom',
  'es_tabi_bottom',
  'es_tabi_image',
]

/** 西班牙税务单中禁止改尺寸的图字段（与 RBP2 `DisableSizeKey` 一致） */
export const PRINT_TEMPLATE_DISABLE_SIZE_KEYS: readonly string[] = [
  'es_verifactu_image',
  'es_tabi_image',
]

/** 模板行分隔占位（与 RBP2 一致） */
export const PRINT_TEMPLATE_NEWLINE = 'NEWLINE' as const

// 模板宽度
export const widthMap = {
  '10': 325,
  '11': 355,
  '12': 355,
  '13': 375,
  '14': 350,
  '15': 350
}

export const ES_IMAGE = {
  es_tabi_image: 'https://tbai.prep.gipuzkoa.eus/qr/?id=TBAI-46886417C-011225-KvnkMv9Anhazb-039&s=B618E_2025_2&nf=33&i=0.00&cr=176',
  es_verifactu_image: 'https://prewww2.aeat.es/wlpl/TIKE-CONT/ValidarQR?nif=N0272386D&numserie=6EECD_202528&fecha=09-12-2025&importe=12.00'
}

// 字体列表
export const PRINT_TEMPLATE_FONT_OPTIONS = [
  { label: 'Arial', value: 'Arial' },
  { label: 'Bahnschrift', value: 'Bahnschrift' },
  { label: 'Calibri', value: 'Calibri' },
  { label: 'Cambria', value: 'Cambria' },
  { label: 'Cambria Math', value: 'Cambria Math' },
  { label: 'Candara', value: 'Candara' },
  { label: 'Comic Sans MS', value: 'Comic Sans MS' },
  { label: 'Consolas', value: 'Consolas' },
  { label: 'Constantia', value: 'Constantia' },
  { label: 'Corbel', value: 'Corbel' },
  { label: 'Courier New', value: 'Courier New' },
  { label: 'DejaVu Math TeX Gyre', value: 'DejaVu Math TeX Gyre' },
  { label: 'Ebrima', value: 'Ebrima' },
  { label: 'Franklin Gothic', value: 'Franklin Gothic' },
  { label: 'Gabriola', value: 'Gabriola' },
  { label: 'Gadugi', value: 'Gadugi' },
  { label: 'Georgia', value: 'Georgia' },
  { label: 'Global Monospace', value: 'Global Monospace' },
  { label: 'Global Sans Serif', value: 'Global Sans Serif' },
  { label: 'Global Serif', value: 'Global Serif' },
  { label: 'Global User Interface', value: 'Global User Interface' },
  { label: 'HoloLens MDL2 Assets', value: 'HoloLens MDL2 Assets' },
  { label: 'Impact', value: 'Impact' },
  { label: 'Ink Free', value: 'Ink Free' },
  { label: 'Javanese Text', value: 'Javanese Text' },
  { label: 'Leelawadee UI', value: 'Leelawadee UI' },
  { label: 'Lucida Console', value: 'Lucida Console' },
  { label: 'Lucida Sans Unicode', value: 'Lucida Sans Unicode' },
  { label: 'Malgun Gothic', value: 'Malgun Gothic' },
  { label: 'Marlett', value: 'Marlett' },
  { label: 'Microsoft Himalaya', value: 'Microsoft Himalaya' },
  { label: 'Microsoft JhengHei UI', value: 'Microsoft JhengHei UI' },
  { label: 'Microsoft JhengHei', value: 'Microsoft JhengHei' },
  { label: 'Microsoft New Tai Lue', value: 'Microsoft New Tai Lue' },
  { label: 'Microsoft PhagsPa', value: 'Microsoft PhagsPa' },
  { label: 'Microsoft Sans Serif', value: 'Microsoft Sans Serif' },
  { label: 'Microsoft Tai Le', value: 'Microsoft Tai Le' },
  { label: 'Microsoft YaHei UI', value: 'Microsoft YaHei UI' },
  { label: 'Microsoft Yi Baiti', value: 'Microsoft Yi Baiti' },
  { label: 'MingLiU-ExtB', value: 'MingLiU-ExtB' },
  { label: 'MingLiU_HKSCS-ExtB', value: 'MingLiU_HKSCS-ExtB' },
  { label: 'Mongolian Baiti', value: 'Mongolian Baiti' },
  { label: 'MS Gothic', value: 'MS Gothic' },
  { label: 'MS PGothic', value: 'MS PGothic' },
  { label: 'MS UI Gothic', value: 'MS UI Gothic' },
  { label: 'MT Extra', value: 'MT Extra' },
  { label: 'MV Boli', value: 'MV Boli' },
  { label: 'Myanmar Text', value: 'Myanmar Text' },
  { label: 'Nirmala UI', value: 'Nirmala UI' },
  { label: 'Noto Sans SC', value: 'Noto Sans SC' },
  { label: 'Palatino Linotype', value: 'Palatino Linotype' },
  { label: 'PMingLiU-ExtB', value: 'PMingLiU-ExtB' },
  { label: 'Segoe MDL2 Assets', value: 'Segoe MDL2 Assets' },
  { label: 'Segoe Print', value: 'Segoe Print' },
  { label: 'Segoe Script', value: 'Segoe Script' },
  { label: 'Segoe UI Emoji', value: 'Segoe UI Emoji' },
  { label: 'Segoe UI Historic', value: 'Segoe UI Historic' },
  { label: 'Segoe UI Symbol', value: 'Segoe UI Symbol' },
  { label: 'Segoe UI', value: 'Segoe UI' },
  { label: 'SimSun-ExtB', value: 'SimSun-ExtB' },
  { label: 'SimSun-ExtG', value: 'SimSun-ExtG' },
  { label: 'Sitka Banner', value: 'Sitka Banner' },
  { label: 'Sitka Display', value: 'Sitka Display' },
  { label: 'Sitka Heading', value: 'Sitka Heading' },
  { label: 'Sitka Small', value: 'Sitka Small' },
  { label: 'Sitka Subheading', value: 'Sitka Subheading' },
  { label: 'Sitka Text', value: 'Sitka Text' },
  { label: 'Sw-JkFont', value: 'Sw-JkFont' },
  { label: 'Sylfaen', value: 'Sylfaen' },
  { label: 'Symbol', value: 'Symbol' },
  { label: 'Tahoma', value: 'Tahoma' },
  { label: 'Times New Roman', value: 'Times New Roman' },
  { label: 'Trebuchet MS', value: 'Trebuchet MS' },
  { label: 'Verdana', value: 'Verdana' },
  { label: 'Webdings', value: 'Webdings' },
  { label: 'Wingdings', value: 'Wingdings' },
  { label: 'Yu Gothic UI', value: 'Yu Gothic UI' },
  { label: 'Yu Gothic', value: 'Yu Gothic' },
  { label: '仿宋', value: '仿宋' },
  { label: '宋体', value: '宋体' },
  { label: '微软雅黑', value: '微软雅黑' },
  { label: '新宋体', value: '新宋体' },
  { label: '楷体', value: '楷体' },
  { label: '等线', value: '等线' },
  { label: '黑体', value: '黑体' }
];
